var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-test" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("产品功能测试")]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "result",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.testResultData.testResult === null,
                  expression: "testResultData.testResult === null",
                },
              ],
              staticClass: "no-data",
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../../../public/images/no-test-report.png"),
                  alt: "",
                },
              }),
              _c("div", { staticClass: "no-text" }, [_vm._v("无测试报告")]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.testResultData.testResult !== null,
                  expression: "testResultData.testResult !== null",
                },
              ],
              staticClass: "box",
            },
            [
              _c("div", [
                _c("span", { staticClass: "label" }, [_vm._v("测试结论")]),
                _vm.testResultData.testResult === 0
                  ? _c("span", { staticClass: "result-data" }, [
                      _c("i", {
                        staticClass: "iconfont icon-shangchuanchenggong",
                      }),
                      _vm._v("\n          通过\n        "),
                    ])
                  : _c("span", { staticClass: "result-data" }, [
                      _c("i", { staticClass: "iconfont icon-shibai" }),
                      _vm._v("\n          不通过\n        "),
                    ]),
              ]),
              _c("div", [
                _c("span", { staticClass: "label" }, [_vm._v("测试报告名称")]),
                _c("span", { staticClass: "result-data" }, [
                  _vm._v(_vm._s(_vm.testResultData.showName)),
                ]),
              ]),
              _c("div", [
                _c("span", { staticClass: "label" }, [_vm._v("上传时间")]),
                _c("span", { staticClass: "result-data" }, [
                  _vm._v(_vm._s(_vm.testResultData.createTime)),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              staticClass: "download",
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "add",
                size: "14",
              },
              on: { click: _vm.downloadReport },
            },
            [
              _c("div", { staticClass: "box" }, [
                _c("i", { staticClass: "iconfont icon-anniuxiazai" }),
                _c("span", { staticClass: "text" }, [_vm._v("下载报告")]),
              ]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "upload",
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "add",
                size: "14",
              },
              on: { click: _vm.uploadReport },
            },
            [
              _c("div", { staticClass: "box" }, [
                _c("i", { staticClass: "iconfont icon-anniushangchuan" }),
                _c("span", { staticClass: "text" }, [_vm._v("上传报告")]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传测试报告",
            visible: _vm.dialogVisible,
            width: "587px",
            "before-close": _vm.handleClose,
            "custom-class": "dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "list" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: { model: _vm.form, "label-width": "0" },
                },
                [
                  _c("div", [_vm._v("测试结果")]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.testResult,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "testResult", $$v)
                            },
                            expression: "form.testResult",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("通过"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("不通过"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", [_vm._v("测试报告")]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "/admin/sys-file/upload",
                            headers: _vm.headers,
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadSuccess,
                            "on-error": _vm.uploadError,
                            multiple: "",
                            accept: _vm.allowedTypes,
                          },
                        },
                        [
                          !_vm.uploadSuccessedFile
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "upload-btn",
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-plus",
                                  },
                                },
                                [_vm._v("点击上传")]
                              )
                            : _c(
                                "el-input",
                                {
                                  staticClass: "file-name",
                                  model: {
                                    value: _vm.file.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.file, "name", $$v)
                                    },
                                    expression: "file.name",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.file.name))]
                              ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "el-upload__tip" }, [
                        _vm._v("支持格式：pdf、xls、xlsx、doc、docx"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "close",
                  attrs: { size: "14" },
                  on: { click: _vm.handleClose },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "14",
                    disabled:
                      _vm.form.testResult === "" || _vm.reportUrl === "",
                  },
                  on: { click: _vm.onsubmit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }